import { CostCenterFilterKeyString } from 'InstitutionalManagement/types'

export const COST_CENTER_FIELDS_INITIAL_VALUES: CostCenterFilterKeyString = {
  id: '',
  name: '',
  description: '',
  status: '',
}
